// axios
import axios from "../axios/axios";

export const getResponseData = (url) => {
  return axios({
    url: url,
    method: "GET",
  });
};
